import type { StickerIllustrationProps } from '../Sticker';

export const FireStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 25C17.3527 25 21.75 20.9622 21.75 15.7794C21.75 14.5071 21.6821 13.1432 20.9412 11.0234C20.6583 10.214 20.4616 9.67372 20.283 9.24222C20.0103 8.5834 18.9588 8.75822 18.6173 9.38413C18.3728 9.83214 18.091 10.1966 17.8165 10.4898C17.3969 10.938 16.4992 10.5967 16.3121 10.012C15.861 8.60236 15.0295 6.46286 13.9615 4.97348C12.7877 3.33655 11.3062 2.1095 10.091 1.17732C9.59584 0.797465 8.84571 1.15933 8.77404 1.77928C8.58081 3.45057 8.11228 5.32615 7.50554 6.41238C6.70181 7.85128 6.55088 7.90369 5.54695 8.9745C4.54308 10.0453 4.0823 10.376 3.24282 11.6753C2.40338 12.9746 2.25 14.7051 2.25 15.9774C2.25 21.1602 6.64747 25 12.0001 25Z"
      fill="#F5BA33"
      stroke="white"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8.38634 17.3657C8.46055 16.5814 9.47071 16.5412 10.0903 17.0278C11.0191 17.7571 12.2393 18.1088 13.4959 17.9003C14.3522 17.7581 15.1078 17.3748 15.7058 16.8317C16.1547 16.4241 16.9253 16.465 17.0246 17.0631C17.4187 19.4374 15.8129 21.6823 13.4386 22.0763C11.0645 22.4701 8.82046 20.8644 8.42642 18.4902C8.36327 18.1096 8.35163 17.7324 8.38634 17.3657Z"
      fill="white"
    />
  </svg>
);
